import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('LEK App Error:', error);
    console.error('Error Info:', errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="lek-app error-boundary">
          <div className="lek-app-container">
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              padding: '40px',
              textAlign: 'center',
              background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
              color: 'white'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>🐟</div>
              <h2 style={{ marginBottom: '16px', color: '#ef4444' }}>
                LEK Application Error
              </h2>
              <p style={{ marginBottom: '20px', color: '#ccc', maxWidth: '500px' }}>
                The Local Ecological Knowledge application encountered an unexpected error.
                Please refresh the page or contact support if the problem persists.
              </p>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '12px 24px',
                  backgroundColor: '#0066cc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '600'
                }}
              >
                Reload Application
              </button>
              
              {process.env.NODE_ENV === 'development' && (
                <details style={{ 
                  marginTop: '20px', 
                  padding: '16px',
                  backgroundColor: 'rgba(239, 68, 68, 0.1)',
                  borderRadius: '6px',
                  border: '1px solid rgba(239, 68, 68, 0.3)',
                  color: '#ef4444',
                  fontSize: '12px',
                  fontFamily: 'monospace',
                  textAlign: 'left',
                  maxWidth: '600px'
                }}>
                  <summary style={{ cursor: 'pointer', marginBottom: '8px' }}>
                    Debug Information (Development Only)
                  </summary>
                  <div style={{ whiteSpace: 'pre-wrap' }}>
                    <strong>Error:</strong> {this.state.error && this.state.error.toString()}
                    <br />
                    <strong>Stack Trace:</strong>
                    <br />
                    {this.state.errorInfo.componentStack}
                  </div>
                </details>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
